import { Vue, Component, Watch } from "vue-property-decorator";
import { sortBy } from "lodash";
import { ReportsModule } from "@/modules/reports-objective";
import { ActionItem, Action, fmtMsg } from "commonui";
import { Button, Select } from "ant-design-vue";
import VersionGroupUnitsSelect from "@/components/version-group-units-select/version-group-units-select.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { UnitRangeQueryParamsModel } from "@/services/component-objective-report";
import CommonHeader from "../common-header/common-header.vue";
import { UnitRangeModel } from "@/services/objective-manager";
import { ReportsLocale } from "@/locales/localeid";
import LabelText from "@/components/label-text/label-text.vue";
import {
	ComponentResponseModel,
	FocusWordsChapterReportService,
	IFocusWordsChapterReportService
} from "@/services/focus-words-by-chapter-report";

@Component({
	components: {
		CommonHeader,
		Action,
		ActionItem,
		VersionGroupUnitsSelect,
		Button,
		Select,
		Option: Select.Option,
		LabelText
	}
})
export default class FocusWordsByChapterHeaderActions extends Vue {
	focusWordsChapterReportService: IFocusWordsChapterReportService = FocusWordsChapterReportService();
	public unitObject: UnitRangeModel = {} as UnitRangeModel;
	public allComponentsData: any = [];
	public allChaptersData: any = [];
	public allFocusWordsData: any = [];
	public componentsSelected: string[] = ["-1"];
	public chaptersSelected: string[] = ["-1"];
	public focusWordsSelected: number[] = [-1];
	public readonly allComponents = "-1";
	public readonly allChapters = "-1";
	public readonly allfocusWords = -1;
	public readonly allString = "-1";
	public readonly allNumber = -1;
	public masterData: ComponentResponseModel[] = [];
	public isComponentDropdownLoading: boolean = false;
	public isChapterDropdownLoading: boolean = false;
	public isFocusWordDropdownLoading: boolean = false;

	get vcsLevelUnits() {
		return sortBy(ReportsModule.vcsUnits, "unit");
	}

	setUnitObject(value) {
		this.unitObject = value;
	}

	@Watch("unitObject")
	getComponentsByUnitsSelected() {
		this.componentsSelected = ["-1"];
		this.chaptersSelected = ["-1"];
		this.focusWordsSelected = [-1];
		this.allComponentsData = [];
		this.allChaptersData = [];
		this.allFocusWordsData = [];
		this.isComponentDropdownLoading = true;
		this.isChapterDropdownLoading = true;
		this.isFocusWordDropdownLoading = true;
		const queryParams: UnitRangeQueryParamsModel = {
			gsVersionId: VersionGroupModule.selectedGsVersion,
			lsVersionId: VersionGroupModule.selectedLsVersion
		};
		this.focusWordsChapterReportService
			.getComponentsByUnitRange(this.unitObject.startUnitId, this.unitObject.endUnitId, queryParams)
			.then((res) => {
				this.masterData = res;
				res.forEach((data) => {
					this.allComponentsData.push({
						componentId: data.contentId,
						componentText: data.contentTitle
					});
					data.chapters.forEach((chapter) => {
						this.allChaptersData.push({
							chapterId: chapter.chapterId,
							chapterText: chapter.chapterTitle
						});

						chapter.focusWords.forEach((focusWord) => {
							if (!this.allFocusWordsData.some((obj) => obj.focusWordId == focusWord.focusWordId)) {
								this.allFocusWordsData.push({
									focusWordId: focusWord.focusWordId,
									focusWordText: focusWord.focusWordText
								});
							}
						});
					});
				});
				this.isComponentDropdownLoading = false;
				this.isChapterDropdownLoading = false;
				this.isFocusWordDropdownLoading = false;
			})
			.catch((err) => {
				console.log(err);
				this.isComponentDropdownLoading = false;
				this.isChapterDropdownLoading = false;
				this.isFocusWordDropdownLoading = false;
			});
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	onSelectedComponentsChange(values) {
		this.componentsSelected = this.getSelectedValues(values, this.allString);
	}

	onSelectedChaptersChange(values) {
		this.chaptersSelected = this.getSelectedValues(values, this.allString);
	}

	onSelectedFocusWordsChange(values) {
		this.focusWordsSelected = this.getSelectedValues(values, this.allNumber);
	}

	@Watch("componentsSelected")
	updateAvailableChapters() {
		this.allChaptersData = [];
		this.allFocusWordsData = [];
		this.chaptersSelected = ["-1"];
		this.focusWordsSelected = [-1];
		this.componentsSelected.forEach((contentId) => {
			this.getChaptersAndFocusWords(contentId);
		});
	}

	getChaptersAndFocusWords(contentId) {
		this.masterData.forEach((currentComponent) => {
			if (contentId == currentComponent.contentId) {
				currentComponent.chapters.forEach((currentChapter) => {
					this.allChaptersData.push({
						chapterId: currentChapter.chapterId,
						chapterText: currentChapter.chapterTitle
					});
					currentChapter.focusWords.forEach((currentFocusWord) => {
						this.allFocusWordsData.push({
							focusWordId: currentFocusWord.focusWordId,
							focusWordText: currentFocusWord.focusWordText
						});
					});
				});
			}
		});
	}

	@Watch("chaptersSelected")
	updatedAvailableFocusWords() {
		this.allFocusWordsData = [];
		this.focusWordsSelected = [-1];
		this.chaptersSelected.forEach((chapterId) => {
			this.getFocusWords(chapterId);
		});
	}

	getFocusWords(chapterId) {
		this.masterData.forEach((currentComponent) => {
			currentComponent.chapters.forEach((currentChapter) => {
				if (currentChapter.chapterId == chapterId) {
					currentChapter.focusWords.forEach((currentFocusWord) => {
						this.allFocusWordsData.push({
							focusWordId: currentFocusWord.focusWordId,
							focusWordText: currentFocusWord.focusWordText
						});
					});
				}
			});
		});
	}

	get reportsLocale() {
		return ReportsLocale;
	}

	getSelectedValues(selectedValues: any, all: number | string) {
		const indexOfAll = selectedValues.lastIndexOf(all);
		if ((indexOfAll != -1 && indexOfAll === selectedValues.length - 1) || selectedValues.length === 0) {
			return [all];
		} else if (indexOfAll != -1 && indexOfAll !== selectedValues.length - 1) {
			const newSelectedValues = selectedValues.filter((v) => v !== all);
			return newSelectedValues;
		} else {
			return selectedValues;
		}
	}

	getReportData() {
		ReportsModule.setComponentObjectiveGridLoading(true);

		const requestBody = {
			StartUnitId: this.unitObject.startUnitId,
			EndUnitId: this.unitObject.endUnitId,
			GsVersionId: VersionGroupModule.selectedGsVersion == "-1" ? null : VersionGroupModule.selectedGsVersion,
			LsVersionId: VersionGroupModule.selectedLsVersion == "-1" ? null : VersionGroupModule.selectedLsVersion,
			ContentId: this.componentsSelected.includes(this.allString) ? null : this.componentsSelected,
			ChapterId: this.chaptersSelected.includes(this.allString) ? null : this.chaptersSelected,
			FocusWordId: this.focusWordsSelected.includes(this.allNumber) ? null : this.focusWordsSelected
		};

		this.focusWordsChapterReportService
			.getFocusWordChapterReportData(requestBody)
			.then((res) => {
				ReportsModule.setFocusWordChapterReportData(res);
				ReportsModule.setComponentObjectiveGridLoading(false);
			})
			.catch((err) => {
				console.log(err);
				ReportsModule.setComponentObjectiveGridLoading(false);
			});
	}
}
